var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFpBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94.302,
    height: 14,
    viewBox: "0 0 94.302 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_20200"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M7.714,1.231h0C6.558.362,6.556.355,6.556.355A2.025,2.025,0,0,0,6.261.168,1.351,1.351,0,0,0,5.92.026,1.566,1.566,0,0,0,5.51-.01H-.244A1.652,1.652,0,0,0-1.477.5,1.723,1.723,0,0,0-2,1.706V9.487a1.794,1.794,0,0,0,.523,1.205c.074.037.112.11.187.146l1.457,1.1c.037.073.112.11.149.146h0a1.66,1.66,0,0,0,.934.292A1.577,1.577,0,0,0,2.857,10.8h0v-.183h0a.576.576,0,0,1,.56-.584h.224c3.25,0,5.866-1.68,5.866-4.968V5.03A4.579,4.579,0,0,0,7.714,1.231Zm-8.742,9.388h0v-.037h-.037v-.037H-1.14v-.037h-.037v-.037h-.037v-.037h0a1.313,1.313,0,0,1-.412-.948V1.706A1.334,1.334,0,0,1-1.215.72a1.465,1.465,0,0,1,.971-.4H5.51c.112,0,.224.037.3.037a2.611,2.611,0,0,1,.3.11,1.291,1.291,0,0,1,.523.475,1.241,1.241,0,0,1,.187.658,1.261,1.261,0,0,1-.374.877h0a1.414,1.414,0,0,1-.934.365H2.147a.967.967,0,0,0-.71.292h0a.955.955,0,0,0,0,1.388.967.967,0,0,0,.71.292H3.791a1.32,1.32,0,0,1,.9.365,1.215,1.215,0,0,1,0,1.753h0a1.172,1.172,0,0,1-.9.366H1.886a.765.765,0,0,0-.523.219h0a.713.713,0,0,0-.224.511v.037h0V8.1h0v.037h0v.037h0v.037h0v.037h0v.037h0v.037h0v.037h0v.037h0v.037h0v.037h0V8.5h0v.037h0v.037h0v.913a1.313,1.313,0,0,1-.411.95h0a1.372,1.372,0,0,1-.971.4,1.4,1.4,0,0,1-.784-.22Z",
    transform: "translate(2 0.012)",
    fill: "#2955d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7498",
    "data-name": "Group 7498",
    transform: "translate(-92 -833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6445",
    "data-name": "Group 6445",
    transform: "translate(108 836.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442",
    transform: "translate(0 -0.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-6475.591-3282.069a1.184,1.184,0,0,1-.344-1v-2.468h-.806v-1.1h.79v-1.3h1.261v1.306h.971v1.1h-.955v2.155c0,.3.16.521.438.521a.678.678,0,0,0,.434-.137l.264.948a1.533,1.533,0,0,1-1.047.308,1.171,1.171,0,0,1-.167.012A1.188,1.188,0,0,1-6475.591-3282.069Zm10.426.326a2.419,2.419,0,0,1-1.816-.7,2.413,2.413,0,0,1-.712-1.811,2.412,2.412,0,0,1,.718-1.8,2.416,2.416,0,0,1,1.81-.7,2.2,2.2,0,0,1,1.886.866l-.823.762a1.181,1.181,0,0,0-1-.515,1.271,1.271,0,0,0-.957.4,1.267,1.267,0,0,0-.338.979,1.279,1.279,0,0,0,.338.984,1.28,1.28,0,0,0,.957.409,1.2,1.2,0,0,0,1-.51l.823.757a2.2,2.2,0,0,1-1.755.875C-6465.077-3281.739-6465.121-3281.74-6465.165-3281.743Zm-7.276-.7a2.427,2.427,0,0,1-.72-1.819,2.429,2.429,0,0,1,.7-1.764,2.431,2.431,0,0,1,1.752-.721,2.39,2.39,0,0,1,2.391,2.627v.273h-3.52a1.283,1.283,0,0,0,1.37,1.1,1.926,1.926,0,0,0,1.272-.472l.549.806a2.926,2.926,0,0,1-1.962.663c-.046,0-.092,0-.138,0A2.416,2.416,0,0,1-6472.441-3282.445Zm.58-2.271h2.352a1.1,1.1,0,0,0-.378-.774,1.091,1.091,0,0,0-.823-.262h-.009A1.147,1.147,0,0,0-6471.861-3284.716Zm40.6,2.5a1.191,1.191,0,0,1-.333-1.023v-2.468h-.79v-1.1h.79v-1.3h1.261v1.3h.971v1.1h-.971v2.155c0,.3.158.549.438.549a.668.668,0,0,0,.434-.137l.264.948a1.528,1.528,0,0,1-1.042.308,1.189,1.189,0,0,1-.178.013A1.189,1.189,0,0,1-6431.265-3282.214Zm-27.968.35v-2.9c0-.663-.35-.871-.893-.871a1.4,1.4,0,0,0-1.1.549v3.223h-1.261v-6.58h1.251v2.44a2.2,2.2,0,0,1,1.682-.74,1.37,1.37,0,0,1,1.145.358,1.372,1.372,0,0,1,.424,1.122v3.4Zm-19.443,0v-2.885a.78.78,0,0,0-.218-.666.775.775,0,0,0-.665-.221,1.366,1.366,0,0,0-1.1.547v3.225h-1.24v-4.766h1.251v.621a2.2,2.2,0,0,1,1.673-.741,1.391,1.391,0,0,1,1.139.387,1.4,1.4,0,0,1,.407,1.132v3.367Zm-5.743,0v-4.764h1.258v4.764Zm-5.582,0v-6.58h4.662v1.207h-3.29v1.425h3.192v1.207h-3.165v2.741Zm74.1-.787.549-.878a2.737,2.737,0,0,0,1.645.648c.547,0,.8-.187.8-.482s-.411-.456-.953-.549c-.824-.153-1.876-.352-1.876-1.487,0-.8.7-1.5,1.953-1.5a2.948,2.948,0,0,1,1.913.653l-.494.855a2.019,2.019,0,0,0-1.409-.549c-.454,0-.75.165-.75.445s.378.4.91.51c.816.16,1.914.378,1.914,1.562,0,.878-.741,1.531-2.062,1.531h-.061A3.224,3.224,0,0,1-6415.9-3282.65Zm-5.095-.453a2.5,2.5,0,0,1-.041-2.569,2.507,2.507,0,0,1,2.241-1.256l0,.011a2.39,2.39,0,0,1,2.391,2.627v.274h-3.542a1.282,1.282,0,0,0,1.37,1.1,1.911,1.911,0,0,0,1.272-.477l.549.813a2.942,2.942,0,0,1-1.963.663q-.075,0-.151,0A2.507,2.507,0,0,1-6420.994-3283.1Zm1.031-1.779h2.354a1.1,1.1,0,0,0-.366-.777,1.1,1.1,0,0,0-.813-.275h-.034A1.146,1.146,0,0,0-6419.963-3284.882Zm-34.966,2.85v-6.579h3.082a2.113,2.113,0,0,1,1.922,1.024,2.115,2.115,0,0,1,0,2.178,2.113,2.113,0,0,1-1.922,1.024h-1.684v2.358Zm1.4-3.564h1.492a.91.91,0,0,0,.847-.432.909.909,0,0,0,0-.951.912.912,0,0,0-.847-.432h-1.492Zm28.754,3.564-1.919-4.764h1.344l1.229,3.318,1.244-3.318h1.355l-1.92,4.764Zm-3.733,0v-4.764h1.256v4.764Zm-5.829,0v-4.764h1.251v4.764Zm-2.5,0v-3.01c0-.443-.2-.762-.711-.762a1.262,1.262,0,0,0-.987.549v3.223h-1.267v-3.01c0-.443-.2-.762-.707-.762a1.265,1.265,0,0,0-.987.549v3.223h-1.272v-4.764h1.256v.619a2.081,2.081,0,0,1,1.557-.74,1.253,1.253,0,0,1,1.321.866,2.032,2.032,0,0,1,1.645-.866,1.283,1.283,0,0,1,1.054.378,1.277,1.277,0,0,1,.35,1.063v3.443Zm-8.411,0v-4.764H-6444v4.764Zm-3.552,0v-4.764h1.249v.646a2.039,2.039,0,0,1,1.524-.756v1.221a1.646,1.646,0,0,0-1.524.505v3.147Zm-35.723-6.051a.756.756,0,0,1,.751-.751.751.751,0,0,1,.751.751.751.751,0,0,1-.751.753A.757.757,0,0,1-6484.521-3288.082Zm55.885-.166a.75.75,0,0,1,.75-.751.751.751,0,0,1,.751.751.752.752,0,0,1-.751.751A.755.755,0,0,1-6428.636-3288.248Zm-5.836,0a.751.751,0,0,1,.752-.751.751.751,0,0,1,.751.751.752.752,0,0,1-.751.751A.757.757,0,0,1-6434.472-3288.248Zm-10.906,0a.751.751,0,0,1,.75-.751.751.751,0,0,1,.752.751.752.752,0,0,1-.752.751A.757.757,0,0,1-6445.378-3288.248Z",
    transform: "translate(6490 3289)",
    fill: "#3f567e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7496",
    "data-name": "Group 7496",
    transform: "translate(-279 578.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5802",
    "data-name": "Rectangle 5802",
    width: 14,
    height: 14,
    transform: "translate(371 254.891)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6965",
    "data-name": "Group 6965",
    transform: "translate(372.246 255.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6966",
    "data-name": "Group 6966",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20200-2",
    "data-name": "Path 20200",
    d: "M-1850.918,13186.572c-.518-.041-6.131,0-6.131,0s-1.189-.156-1.474,1.324a11.113,11.113,0,0,0,0,1.256c0,.574-.016,1.422,0,2.344.035,2.018.056,4.246.056,4.246s-.272,1.078,1.417,1.795a1.792,1.792,0,0,0,2.4-.986l.885-1.362s1.526-.622,1.553-.659,2.235-2.158,2.235-2.158.667-1,.667-1.039.245-1.51.245-1.51l-.163-1.092-.6-1.5A2.167,2.167,0,0,0-1850.918,13186.572Z",
    transform: "translate(1858.686 -13186.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.25, -0.78)",
    filter: "url(#Path_20200)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20200-3",
    "data-name": "Path 20200",
    d: "M-1850.918,13186.572c-.518-.041-6.131,0-6.131,0s-1.189-.156-1.474,1.324a11.113,11.113,0,0,0,0,1.256c0,.574-.016,1.422,0,2.344.035,2.018.056,4.246.056,4.246s-.272,1.078,1.417,1.795a1.792,1.792,0,0,0,2.4-.986l.885-1.362s1.526-.622,1.553-.659,2.235-2.158,2.235-2.158.667-1,.667-1.039.245-1.51.245-1.51l-.163-1.092-.6-1.5A2.167,2.167,0,0,0-1850.918,13186.572Z",
    transform: "translate(1859.93 -13185.6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3008",
    "data-name": "Mask Group 3008",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20072",
    "data-name": "Path 20072",
    d: "M6.157,0l4.027.037a6.325,6.325,0,0,1,6.274,6.206l.041,4.33a6.043,6.043,0,0,1-6.157,6.09l-4.027-.037A6.325,6.325,0,0,1,.041,10.42L0,6.09A6.043,6.043,0,0,1,6.157,0Z",
    transform: "translate(-9.839 -3.75) rotate(-30)",
    fill: "#2955d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20073",
    "data-name": "Path 20073",
    d: "M2.771,0,13.634.1A2.846,2.846,0,0,1,16.458,2.9l.105,11.093a2.719,2.719,0,0,1-2.771,2.74l-10.864-.1A2.846,2.846,0,0,1,.105,13.833L0,2.741A2.719,2.719,0,0,1,2.771,0Z",
    transform: "translate(-1.791 9.942) rotate(-30)",
    fill: "#2955d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20074",
    "data-name": "Path 20074",
    d: "M0,0,14.311.134l.134,14.15L.134,14.15Z",
    transform: "translate(1.302 -5.988) rotate(-30)",
    fill: "#3e74ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20075",
    "data-name": "Path 20075",
    d: "M.134.134,14.275,0l-.134,14.3L0,14.435Z",
    transform: "translate(7.422 -3.745) rotate(60)",
    fill: "#3e74ff"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpBadge);
export default __webpack_public_path__ + "static/media/fp-badge.15bf710167b46bf3b33298ab53a0de0e.svg";
export { ForwardRef as ReactComponent };